<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Lista de Comisiones</p>
        </template>
        <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover 
                :items="sellerList">
                <template v-slot:cell(nombre)="data">
                    {{ data.item.nombre }}
                </template>
                <template v-slot:cell(email)="data">
                    {{ data.item.email }}
                </template>
                <template v-slot:cell(telefono)="data">
                    {{ data.item.telefono }}
                </template>
                <template v-slot:cell(totalSalesCommissions)="data">
                  $ {{ numberFormat(data.item.totalSalesCommissions) }} COP
                </template>
                <template v-slot:cell(commission_percentage_on_sales)="data">
                    {{ data.item.commission_percentage_on_sales }}
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button variant="info" size="sm" v-b-tooltip.hover.right title="Ver Ventas" class="text-white" 
                    @click.prevent="$emit('open-seller-order-list', item)">
                        <b-icon icon="search"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="sellerList.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
        <template v-slot:footer>
            <div class="mt-3">
                <b-row>                            
                    <b-col cols="12" md="4">
                        <b-pagination 
                            size="md" 
                            pills 
                            :total-rows="paginator.totalPage" 
                            v-model="paginator.page" 
                            :per-page="1" 
                            @input="changePage" 
                            first-number 
                            last-number>
                        </b-pagination>
                    </b-col>
                    <b-col cols="12" sm="2">
                        <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                    </b-col>
                </b-row>
            </div>
        </template>
    </b-card>
</template>

<script>
export default {
    name: "SalesCommissionTrackerTable",
    props: {
        sellerList: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        }
    },
    data(){
        return{
            fields: [
                { key: 'nombre', label: 'Nombre Vendedor', sortable: true},
                { key: 'email', label: 'Correo electronico', sortable: true},
                { key: 'telefono', label: 'Telefono'},
                { key: 'totalSalesCommissions', label: 'Comisiones de ventas', sortable: true},
                { key: 'commission_percentage_on_sales', label: '% Comisión de venta actual', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
        }
    },
    methods: {
        updatePageSize(){
            this.paginator.page = 1;
            this.$emit('get-seller-list');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);
        }
    }
};

</script>
<style scoped>

</style>